module.exports = __webpack_public_path__ + "static/img/7079_phase_function_Paper_PointsHejduk_Prediction.fd358ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7079_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Dl/i
// module chunks = 0